import IconButton from '@components/IconButton'

import './styles.scss'

const Chip = ({ handleRemove, label }) => (
    <div className="chip">
        <span className="chip__text">{label}</span>
        <IconButton icon="close" className="chip__btn" onClick={handleRemove} />
    </div>
)

Chip.propTypes = {
    handleRemove: PropTypes.func.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

export default Chip
